'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = GoogleMapUrl;

var _lodash = require('lodash');

function GoogleMapUrl(object) {
  var zoom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 18;
  var directions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var latLng = (0, _lodash.get)(object, 'geoIndexed[1]') + ',' + (0, _lodash.get)(object, 'geoIndexed[0]');

  if (directions) {
    return 'https://www.google.com/maps/dir//' + latLng + '/@' + latLng + ',' + zoom + 'z';
  }
  return 'https://www.google.com/maps/place/' + latLng + '/@' + latLng + ',' + zoom + 'z';
}


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-utilities/build/GoogleMapUrl.js
// module id = 1003
// module chunks = 0